<!-- src/App.vue -->
<template>
  <div id="app">
    <router-view></router-view>
</div>
</template>

<script>
import 'bootstrap/dist/css/bootstrap.min.css';
import "@/assets/css/icons.min.css";
import "@/assets/css/vendor.min.css";

export default {
  name: 'App',
};
</script>
